module.exports = __webpack_public_path__ + "img/type-3.9bd4dd27.png";